import {
  BankCardReceiveIcon,
  BoardPinIcon,
  CalendarIcon,
  CircleClockIcon,
  FoodIcon,
  getContractTypeLabel,
  getLanguageLabel,
  HourglassIcon,
  LanguageIcon,
  LocationIcon,
  PaperIcon,
  SevenDaysCalendarIcon,
  Typography,
  User2Icon,
  UsersIcon,
  WalletIncomeIcon,
} from "@cpj-ai/panel-npm-package";
import { AuthAccountLanguageCertificateLanguageChoices, GetJobPositionByIdQuery } from "@graphql/generated";
import React from "react";

interface GeneralInformationProps {
  jobPositionData?: GetJobPositionByIdQuery | null;
  className?: string;
}

export const GeneralInformation: React.FC<GeneralInformationProps> = ({ className, jobPositionData }) => {
  const jobPosition = jobPositionData?.organization?.jobPosition?.get;

  const generalInformationItems = [
    {
      icon: UsersIcon,
      title: "Number of Vacancies",
      value: jobPosition?.vaccancy,
    },
    {
      icon: SevenDaysCalendarIcon,
      title: "Start Date",
      value: jobPosition?.startAt,
    },
    {
      icon: User2Icon,
      title: "Age Requirement",
      value: jobPosition?.ageRange?.join(" - "),
    },
    {
      icon: LocationIcon,
      title: "Location",
      value: jobPosition?.cities.edges.map((item) => item?.node?.name).join(", "),
    },
    {
      icon: PaperIcon,
      title: "Contract Type",
      value: getContractTypeLabel(jobPosition?.contractType),
    },
    {
      icon: LanguageIcon,
      title: "Required Languages",
      value: jobPosition?.languages
        ?.map((item) => getLanguageLabel(item as unknown as AuthAccountLanguageCertificateLanguageChoices))
        .join(", "),
    },
    {
      icon: LanguageIcon,
      title: "Native Languages",
      value: jobPosition?.nativeLanguages
        ?.map((item) => getLanguageLabel(item as unknown as AuthAccountLanguageCertificateLanguageChoices))
        .join(", "),
    },

    {
      icon: WalletIncomeIcon,
      title: "Salary",
      value: jobPosition?.salaryRange?.join(" - "),
    },
    {
      icon: BankCardReceiveIcon,
      title: "Payment Terms",
      value: jobPosition?.paymentTerm?.toLowerCase(),
    },
    {
      icon: HourglassIcon,
      title: "Work Experience(Duration)",
      value: jobPosition?.workExperienceYearsRange?.join(" - "),
    },
    {
      icon: CircleClockIcon,
      title: "Working Hours",
      value:
        jobPosition?.workingStartAt &&
        jobPosition?.workingEndAt &&
        `${jobPosition?.workingStartAt} - ${jobPosition?.workingEndAt}`,
    },
    {
      icon: CalendarIcon,
      title: "Days Off",
      value: jobPosition?.daysOff?.join(", ").toLowerCase(),
    },
    {
      icon: FoodIcon,
      title: "Benefits",
      value: [...(jobPosition?.benefits?.map((item) => item?.name) || []), ...(jobPosition?.otherBenefits || [])].join(
        ", ",
      ),
      wrap: true,
    },
    {
      icon: BoardPinIcon,
      title: "Required Documents",
      value: jobPosition?.requiredDocuments?.join(", "),
      wrap: true,
    },
  ];

  return (
    <div>
      <Typography className="font-medium">General information :</Typography>
      <div className={className ? className : "flex flex-col gap-5 mt-6"}>
        {generalInformationItems.map((item) => (
          <div key={item.title} className={`${item.wrap ? "col-span-3" : "col-span-3 lg:col-span-1"} flex gap-2`}>
            <item.icon className="min-w-6 w-6 h-6 opacity-60" />
            <p>
              <span className="text-sm text-zinc-600 text-nowrap">{item.title} : </span>
              <span className="text-sm">{item.value || "-"}</span>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
